// `/voice/$linkedinAccountId` — voice editor route (Wave 5b Agent 5b.3).
//
// The voice editor mounts inside the `_authed` shell. Wave 5b.1 (LinkedIn
// Accounts) owns the per-account picker that links here; this route just
// reads `:linkedinAccountId` from the URL and hands it down.

import { createRoute } from '@tanstack/react-router';

import { VoiceEditorPage } from '@/features/voice/VoiceEditorPage';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'voice/$linkedinAccountId',
  component: VoiceRoute,
});

function VoiceRoute() {
  const { linkedinAccountId } = Route.useParams();
  return <VoiceEditorPage linkedinAccountId={linkedinAccountId} />;
}
